import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Eye } from '@phosphor-icons/react';

export function ImpersonationBanner() {
  const { user, isImpersonating, stopImpersonating } = useAuth();
  const navigate = useNavigate();

  if (!isImpersonating) return null;

  const roleLabels = { admin: 'Administrador', contractor: 'Contratista', worker: 'Trabajador', client: 'Mandante' };

  const handleBack = async () => {
    await stopImpersonating();
    navigate('/admin/users');
  };

  return (
    <div className="fixed top-0 left-0 right-0 z-[100] bg-amber-400 text-black px-4 py-2 flex items-center justify-between shadow-lg" data-testid="impersonation-banner">
      <div className="flex items-center gap-2 text-sm font-medium">
        <Eye size={18} weight="bold" />
        <span>Viendo como:</span>
        <span className="font-bold">{user?.first_name} {user?.last_name}</span>
        <span className="bg-black/10 rounded px-2 py-0.5 text-xs font-semibold">{roleLabels[user?.role] || user?.role}</span>
        {user?.company_name && <span className="text-black/60 text-xs">({user.company_name})</span>}
      </div>
      <button
        onClick={handleBack}
        className="flex items-center gap-1.5 bg-black/15 hover:bg-black/25 rounded-full px-3 py-1 text-sm font-semibold transition-colors"
        data-testid="stop-impersonating-btn"
      >
        <ArrowLeft size={14} weight="bold" /> Volver a Admin
      </button>
    </div>
  );
}
